import { render, staticRenderFns } from "./ClothingTool.vue?vue&type=template&id=70b32bef&"
import script from "./ClothingTool.vue?vue&type=script&lang=js&"
export * from "./ClothingTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports